<template>
  <div>
    <!-- NEW specialties  -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="newSpecialtyDialog"
      max-width="500px"
    >
      <NewSpecialties
        :specialties="currentSpecialties"
        v-if="newSpecialtyDialog"
        @action="newSpecialtyDialog = true"
        @close="(newSpecialtyDialog = false), updateTable()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Dialog DELETE  -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="deleteDialog"
      max-width="550px"
    >
      <DeleteModal
        title="Deletar"
        textMessage="Tem certeza que deseja deletar esta categoria?"
        cancelBtn="Cancelar"
        okbtn="Deletar"
        textObservation="produto(s) armazena(m) essa categoria. Ao excluí-la você também as retira do cadastro desse(s) produto(s) "
        v-if="deleteDialog"
        icone="mdi-restore-alert"
        @close="(deleteDialog = false), updateTable()"
        @action="(deleteDialog = false), remove()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-row class="d-flex flex-row pt-3 pr-6 pl-6 pb-2">
      <v-col
        class="d-flex flex-column align-start my-1 py-1"
        cols="12"
        lg="4"
        md="4"
        sm="4"
      >
        <v-text-field
          v-model="filter.name"
          class="filterAutocomplete"
          label="Nome"
          attach
          dense
          outlined
          hide-no-data
          hide-details
          cache-items
          v-on:keyup="filterTable()"
          :loading="loading"
        ></v-text-field>
      </v-col>

      <v-col
        class="d-flex flex-row justify-center my-1 py-1"
        cols="12"
        lg="4"
        md="4"
        sm="4"
      >
        <v-btn
          class="mr-2 config black--text"
          style="border: 1px solid; box-sizing: border-box; border-radius: 10px"
          @click="reset"
          :loading="loading"
        >
          <v-icon color="#2D3038" class="pr-1">mdi-cached</v-icon>
          <span> Limpar Filtros</span>
        </v-btn>
      </v-col>

      <v-col
        class="d-flex flex-row justify-center my-1 py-1"
        cols="12"
        lg="4"
        md="4"
        sm="4"
      >
        <v-btn
          class="mr-2"
          color="normalred"
          style="border: 1px solid #bc0000; box-sizing: border-box; border-radius: 10px"
          @click="
            currentSpecialties = {};
            newSpecialtyDialog = true;
          "
          :loading="loading"
        >
          <span>Nova Especialidade</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      ref="table"
      :loading="loading"
      loading-text="Carregando..."
      no-data-text="Nenhuma especialidade foi encontrada..."
      :headers="headers"
      :items="specialtiesArray"
      class="elevation-1 mytable"
      hide-default-footer
      :items-per-page="pageSize"
      :header-props="headerProps"
    >
      <template v-slot:[`item.name`]="{ item }">
        {{ item.name }}
      </template>

      <template v-slot:[`item.actions`]="{ item }" cols="12" md="6" xs="12" sm="12">
        <v-tooltip v-if="item.id <= 8" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              style="border-radius: 6px"
              color="quaternary"
              v-bind="attrs"
              v-on="on"
            >
              Default
            </v-btn>
          </template>
          <span>Especialidade padrão</span>
        </v-tooltip>

        <v-tooltip v-if="item.id > 8" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              fab
              tile
              style="border-radius: 6px"
              small
              class="table-button ma-1 edit-button"
              color="quaternary"
              @click="editSpecialties(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip v-if="item.id > 8" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              fab
              tile
              style="border-radius: 6px"
              small
              class="table-button ma-1 edit-button"
              color="red"
              @click="deleteSpecialties(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>Remover</span>
        </v-tooltip>
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </div>
</template>

<style scoped>
.config {
  background-color: #ffffff !important;
  border: 1px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 10px;
  height: 50px;
}

.tabs {
  background-color: #eceef1;
}
.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  box-sizing: border-box !important;
  border-radius: 8px !important;
  width: 100% !important;
}

.table-button {
  font-weight: bold !important;
  transition: 300ms !important;
}

.table-button:hover {
  background: #2d3038 !important ;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 1024px) {
  .mytable {
    max-width: 100%;
  }
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .theme--light.v-data-table thead tr:last-child th,
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
  .theme--light.v-data-table tbody tr td,
  .theme--light.v-data-table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row) {
    border-bottom: medium solid black !important;
  }
}
</style>

<script>
import ApiService from "../../../../../services/ApiService";
import Vue from "vue";
import DeleteModal from "../../../components/DeleteModal.vue";
import NewSpecialties from "../../components/newSpecialties.vue";

export default {
  props: {
    title: String,
    specialties: Object,
    filtro: Object,
  },

  components: {
    NewSpecialties,
    DeleteModal,
  },

  data: () => ({
    quantSpecialtiesProduct: "",
    specialtiesArray: [],
    newSpecialtyDialog: false,
    deleteDialog: false,
    closeNoLoading: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    currentSpecialties: {},
    categories: [],
    page: 1,
    totalPages: 1,
    currentPage: 1,
    totalItems: 1,
    pageSize: 15,
    filter: {
      page: 1,
      pageSize: 15,
    },
    btnColor: "",
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    error: false,
    show: false,
    message: "",
    headers: [
      { text: "Nome", align: "center", class: "item", value: "name" },
      {
        text: "Aplicadores",
        class: "item",
        value: "",
        align: "center",
      },
      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
  }),

  computed: {},

  async created() {
    await this.updatePageView();
  },

  methods: {
    async updatePageView() {
      // this.filter.Name = null;
      await this.updateTable();
    },

    editSpecialties(item) {
      this.currentSpecialties = item;
      this.newSpecialtyDialog = true;
      this.$emit("editSpecialties", item);
    },

    async deleteSpecialties(item) {
      this.currentSpecialties = item;

      // await this.apiService
      //   .get(`specialties/listBySpecialties/${this.currentSpecialties.specialtiesId}`)
      //   .then((response) => {

      //     this.quantSpecialtiesProduct = response.length;
      //   })
      //   .catch(() => {});

      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    async remove(item) {
      this.loading = true;
      await this.apiService
        .delete(`specialties/delete`, this.currentSpecialties)
        .then(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Especialidade removida com sucesso!",
            message: "Especialidade removida com sucesso!",
            trace: null,
          });
          this.updateTable();
          this.loading = false;
          this.deleteDialog = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível excluir esta especialidade",
            message: err.body.message,
            trace: null,
          });

          this.close();
          this.deleteDialog = false;
          this.loading = false;
          this.$router.push("/installers-config");
        });
    },

    action() {
      this.$emit("action");
    },

    async backPage() {
      this.page -= 1;
      this.filter.page = this.page;
      await this.updateTable();
    },

    async nextPage() {
      this.page += 1;
      this.filter.page = this.page;
      await this.updateTable();
    },

    async updateTable() {
      this.loading = true;
      this.isLoading = true;
      await this.apiService
        .post(`specialties/list`, this.filter)
        .then((response) => {
          this.totalPages = response.pager.totalPages;
          this.totalItems = response.pager.totalItems;
          this.currentPage = response.pager.currentPage;
          this.specialtiesArray = response.specialties;
          this.loading = false;
          this.isLoading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.close();
        });
    },

    close() {
      this.$emit("close");
    },
    reset() {
      this.filter = {
        page: 1,
        pageSize: 15,
      };
      this.page = 1;
      this.updateTable();
    },

    filterTable() {
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;
      this.updateTable();
    },
  },

  watch: {},
};
</script>
s
